module.exports = __webpack_public_path__ + "img/1440.302b59a5.jpg";